export enum LogLevel {
  ALL = 0,
  DEBUG,
  INFO,
  WARNING,
  ERROR,
  FATAL,
  OFF
}
